import { render, staticRenderFns } from "./DouyinQrcode.vue?vue&type=template&id=44eadf10&scoped=true"
import script from "./DouyinQrcode.vue?vue&type=script&lang=js"
export * from "./DouyinQrcode.vue?vue&type=script&lang=js"
import style0 from "./DouyinQrcode.vue?vue&type=style&index=0&id=44eadf10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44eadf10",
  null
  
)

export default component.exports